import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { AddloandetailsComponent } from '../addloandetails/addloandetails.component';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddloantypepopupComponent } from '../../generalpopup/addloantypepopup/addloantypepopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { LoanpauseComponent } from '../loanpause/loanpause.component';
import * as moment from 'moment';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';


@Component({
  selector: 'app-addloan',
  templateUrl: './addloan.component.html',
  styleUrls: ['./addloan.component.css']
})
export class AddloanComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;

  formname: string = "LOAN";

    //Filter
    filterstatus: string = "ALL";
    filteremployeeid: any = null;
    filteremployeename: any = null;
    filterfromdate: any = null;
    filtertodate: any = null;
    filterloantypeid: any = null;
    filterloantype: any = null;
    
  //Display
  formmode: string = "Add";
  rtnform: string = "";

  isloantypeaddmode: boolean = false;
  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;
  ispaymentmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;

  ismanualclose: boolean;

  isemploading: boolean = false;

  attachmentcount: number = 0;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  //Edit Get Values
  loanColl: any = [];
  loanid: number = 0
  loanBO: any = {}
  
   loandetailsColl: any = [];
   loansummaryBO:any={}
  
   loantypeColl:any=[];
  empColl: any = [];
  empBO: any = {};

  paidamount: any = 0;
  remainingamount: any = 0;
  loanperc: any = 0;
  completionmonth: any ='';

   loanform=new FormGroup({
    loanid:new FormControl(0),          
    empid:new FormControl(null,Validators.required),
    loantypeid:new FormControl(null,Validators.required),  
    transdt:new FormControl(null,Validators.required), 
    installments:new FormControl(null,[Validators.min(0.01), Validators.required]),   
    amount:new FormControl(null,Validators.required), 
     descr: new FormControl(''),  
     startdt: new FormControl(null, Validators.required), 
     installmentsamount:new FormControl(null,[Validators.min(0.01), Validators.required]), 
    inactive:new FormControl(false),  
   });
  
   dateCustomClasses: DatepickerDateCustomClasses[];
  
  moment: any = moment;
  
  constructor(private appService: AppdataService, private confirmationDialogService: ConfirmationDialogService,
    private loginService: LoginserviceService, private route: ActivatedRoute,
      public router: Router,private toastr: ToastrService, private productFindService: NgbModal,private datePipe: DatePipe) { 
        this.route.queryParams.subscribe(params => {
          if(params.id!==undefined){
            this.loanid = params.id
          }          

          if(params.rtnform!==undefined){
            this.rtnform = params.rtnform
          }  
          
        });
        this.fnGetParameterVariable();
        this.fnServiceChanges();
        
        this.dateCustomClasses = [
          { date: new Date(), classes: ['bg-warning'] },
        ];
  }
   //Get Para
 fnGetParameterVariable() {
  this.route.queryParams.subscribe(params => {
    if (params.empid !== undefined) {
      this.filteremployeeid = params.empid
    }

    if (params.empname !== undefined) {
      this.filteremployeename = params.empname
    }

    if (params.status !== undefined) {
      this.filterstatus = params.status
    }

    if (params.fromdate !== undefined) {
      this.filterfromdate =  this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
    }

    if (params.todate !== undefined) {
      this.filtertodate =  this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
    }
    if (params.loantypeid !== undefined) {
      this.filterloantypeid = params.loantypeid
    }

    if (params.loantype !== undefined) {
      this.filterloantype = params.loantype
    }
   })
  }
    
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.loanform.reset();
      this.fnInitializeFormGroup();

      if (this.loanid > 0) {
        this.fngetLoan();
      }
      this.fngetLoanType();
      this.fngetEmployee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.loanid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')
    this.ispaymentmode= this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')
    this.isloantypeaddmode= this.loginService.fnCheckUserRoleAction("LoanType", 'CREATE')

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.loanform.setValue({
      loanid: 0,
      loantypeid: null,
      empid: null,
      transdt: new Date(),
      installments: null,
      amount: null,
      descr: '',
      startdt: this.loginService.fnLastDate(new Date()),
      installmentsamount: null,
      inactive: false
    })
  }

  fngetLoanType() {
    var data = {
      'loantypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLoanType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.loantypeColl = res.json().result;
          
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmployee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetLoan() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'loanid': this.loanid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.fngetLoan(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            var result = res.json().result;
            this.loanColl = result[0];
            var editdata = this.loanColl[0];
            this.loanBO = editdata;
            this.fnEditMode(editdata);


            this.loandetailsColl = result[1];
              
            if (result[2].length > 0) {
              this.loansummaryBO = result[2][0];
           
              if (this.loansummaryBO.paidamount) {
                this.paidamount = this.loansummaryBO.paidamount;
              }
              if (this.loansummaryBO.remainingamount) {
                this.remainingamount = this.loansummaryBO.remainingamount;  
              }
              else {
                this.remainingamount = this.loanBO.amount; 
              }

              if (this.loansummaryBO.completeperc) {
                this.loanperc = this.loansummaryBO.completeperc;
              }

              if (this.loansummaryBO.completionmonth) {
                this.completionmonth = this.loansummaryBO.completionmonth;
              }
              
            }
            else {
             
              this.remainingamount = this.loanBO.loanamount; 
              this.completionmonth = this.loanBO.completionmonth; 
            }

            if (! this.completionmonth) {
              this.completionmonth = this.loanBO.completionmonth; 
            }



          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.loanform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;
    
      if (this.loginService.fnCheckFornControlNotfound(this.loanform.get('startdt'))) {
        this.loanform.controls['startdt'].setErrors(null);
      }
     
      //Validate
      if (this.loanform.valid) {
              
        if(this.loginService.fnCompareDateValidation(this.loanform.get('startdt').value,this.loanform.get('transdt').value)){
          this.loanform.controls['startdt'].setErrors({'notfound': true});
          return
        }


        //Check
        var data = {
          'loanid': this.loanid,
          'loantypeid': this.loanform.get('loantypeid').value,
          'empid': this.loanform.get('empid').value,
          'transdt': this.fnFormatDatetime(this.loanform.get('transdt').value),
          'amount': this.loanform.get('amount').value,
          'installments': this.loanform.get('installments').value,
          'descr': this.loanform.get('descr').value,
          'startdt': this.fnFormatDatetime(this.loanform.get('startdt').value),
          'installmentsamount': this.loanform.get('installmentsamount').value,
          'inactive': this.loanform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.loanform.get('loanid').value > 0) {
          //Update 
          this.fnSetLoan(data);
        }
        else {
          //Insert 
          this.fnInsertLoan(data);
        }


      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertLoan(data) {

    this.appService.fnInsertLoan(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          console.log(res.json().result);
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new loan has been added successfully.Insert Successfully");
          this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
          
          var _result = res.json().result;           
          if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].loanid);              
          }
          
          // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetLoan(data) {

    this.appService.fnSetLoan(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          console.log(res.json().result);
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The loan has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.loanid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.loanid);
          
            // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }

  //AddLoanType
  private fnAddLoanType() {

    const modalRef = this.productFindService.open(AddloantypepopupComponent, { size: <any>'xl' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetLoanType();

      if (receivedEntry > 0) {
        this.loanform.patchValue({ loantypeid: receivedEntry })
      }
    });

  }
  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.loanid;
    modalRef.componentInstance.formname = this.formname;

    modalRef.componentInstance.transdate = this.loanBO.transdt;
    modalRef.componentInstance.transpaymodeid = this.loanBO.transpaymodeid;
    modalRef.componentInstance.refno = this.loanBO.payrefno;
    modalRef.componentInstance.paiddt =  this.fnConvertDatetime(this.fnFormatDatetime(this.loanBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.loanBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetLoan();
      }

    });
  }
  public fnRemovePayment() {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to Remove Payment?')
        .then((confirmed) => {
          if (confirmed) {
           this.fnSetRemovePayment()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  private fnSetRemovePayment() {
    var data = {
      'trxid': this.loanid,
      'formname': this.formname,
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.fnSetRemovePayment(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The Payment has been Removed successfully.");
            //this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetLoan();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fnAddLoanPause() {

    const modalRef = this.productFindService.open(LoanpauseComponent, { size: <any>'l' });
    modalRef.componentInstance.loanid = this.loanid;
    modalRef.componentInstance.ispauseloan = this.loanBO.ispauseloan;
    modalRef.componentInstance.pauseon =this.fnConvertDatetime(this.fnFormatDatetime( this.loanBO.pauseon));
    modalRef.componentInstance.resumeon =this.fnConvertDatetime(this.fnFormatDatetime( this.loanBO.resumeon));
    modalRef.componentInstance.pausedesc = this.loanBO.pausedesc;



    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetLoan();
      }

    });
  }
    //#Attachment
    fnAttachmentBtnClick() {

      const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
      modalRef.componentInstance.formname = this.formname;
      modalRef.componentInstance.trxid = this.loanid;
      modalRef.componentInstance.formmode = "EDIT";
      modalRef.componentInstance.fnGetAttachment();
  
      
    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })
      
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
        if (receivedEntry === 'DONE') {
          this.fngetLoan();
        }
      }); 
  

  
    }
  
  
    fnAttachmentSave(tid) {

  
    }
  
    fnSetAttachmentCount(data) {
  
      this.attachmentcount = data;
    }

  fnEditFormEdit(id) {

    this.loanid=id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


      let queryParams= {
        'id':id,
        'status': this.filterstatus,
        'empid': this.filteremployeeid,
        'empname': this.filteremployeename,
        'fromdate': this.fnFormatDatetime(this.filterfromdate),
        'todate': this.fnFormatDatetime(this.filtertodate),
        'loantypeid': this.filterloantypeid,
        'loantype': this.filterloantype,
      }

      this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
        this.ngOnInit();      
      });
      
  
  }

  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;

      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
            'loantypeid': this.filterloantypeid,
            'loantype': this.filterloantype,
          }
        }
  
        this.router.navigate(['/Loan'], navigationExtras);
      }


    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));

    this.loanform.setValue({
      loanid: deptBO.loanid,
      loantypeid: deptBO.loantypeid,
      empid: deptBO.empid,
      transdt: deptBO.transdt,
      //othours:deptBO.othours,
      descr: deptBO.descr,
      installments: deptBO.installments,
      amount: deptBO.amount,
      startdt: deptBO.startdt,
      installmentsamount: deptBO.installmentsamount,
      inactive: deptBO.inactive
    });
    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();
    this.fnChangeEmpLookup();
    this.fnGetAttachmentCount();
  }


  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetLoan();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.loanBO.approvedstatus !== '') {
      if (this.loanBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.loanBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }


  fnAddLoanDetails() {
    const modalRef = this.productFindService.open(AddloandetailsComponent, { size: <any>'l' });


    modalRef.componentInstance.loanremainingamount = this.remainingamount;
    modalRef.componentInstance.remainingamount = this.remainingamount;
    if (this.remainingamount > this.loanBO.installmentsamount) {
      modalRef.componentInstance.amount = this.loanBO.installmentsamount;  
    } else {
      modalRef.componentInstance.amount = this.remainingamount;
    }
    
    modalRef.componentInstance.effectivedt = new Date();
    modalRef.componentInstance.loandt = this.loanform.get('transdt').value;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnInsertDocumentDetails(receivedEntry);
    });
  }


  fnInsertDocumentDetails(reqdata) {
    var data = {
      'loanid': this.loanid,
      'effectivedt': this.fnFormatDatetime(reqdata.effectivedt),
      'amount': reqdata.amount,
      'descr': reqdata.descr,
      'refno': reqdata.refno,
      'createdby': this.loginService.fnGetModUserId(),
      'modifiedby': this.loginService.fnGetModUserId(),
    }


    this.appService.fnInsertLoanDetails(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.fngetLoan();
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });


  }


  fnActionEditClick(index) {
    if (index < 0) {
      return;
    }


    var data = this.loandetailsColl[index]



    const modalRef = this.productFindService.open(AddloandetailsComponent, { size: <any>'l' });


    modalRef.componentInstance.loandetid = data.loandetid;
    modalRef.componentInstance.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(data.effectivedt));
    modalRef.componentInstance.amount = data.amount;
    modalRef.componentInstance.descr = data.descr;
    modalRef.componentInstance.refno = data.refno;
    modalRef.componentInstance.loandt = this.loanform.get('transdt').value;

    modalRef.componentInstance.loanremainingamount = data.amount + this.loansummaryBO.remainingamount;
    modalRef.componentInstance.remainingamount = this.loansummaryBO.remainingamount;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fnSetDocumentDetails(receivedEntry);
    });

  }



  fnSetDocumentDetails(reqdata) {
    var data = {
      'loandetid': reqdata.loandetid,
      'effectivedt': this.fnFormatDatetime(reqdata.effectivedt),
      'amount': reqdata.amount,
      'descr': reqdata.descr,
      'refno': reqdata.refno,
      'createdby': this.loginService.fnGetModUserId(),
      'modifiedby': this.loginService.fnGetModUserId(),
    }


    this.appService.fnSetLoanDetails(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.fngetLoan();
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });


  }


  fnSetTable() {

  }

  fnCalculateInstallment(event, type) {
 
    var installment = 0;
    var loanamount = 0;
    var installmentamount = 0;

    installment = this.loanform.get('installments').value;
    loanamount = this.loanform.get('amount').value;
    installmentamount = this.loanform.get('installmentsamount').value;

    if (!installment) {
      installment = 0.00;
    }

    if (!installmentamount) {
      installmentamount = 0.00;
    }

    if (!loanamount) {
      loanamount = 0.00;
    }
  
    
    if (type === 'AMOUNT' && installment > 0) {      
      type = 'INSTALLMENT';
    }
    else if (type === 'AMOUNT' && installmentamount > 0) {
      type = 'INSTALLMENTAMOUNT';
    }
    else if (type === 'AMOUNT' && installment === 0 && installmentamount === 0) {    
      return;
    }
    

    if (type === 'INSTALLMENT') {

      if (installment > 0) {
        installmentamount = loanamount / installment;
      }
      else {
        installmentamount = 0;

      }
      //installmentamount =installmentamount.toFixed(2); 
    }

    else if (type === 'INSTALLMENTAMOUNT') {
      installmentamount = event;
      if (!installmentamount) {
        installmentamount = 0;
      }
      if (installmentamount > 0) {
        installment = loanamount / installmentamount;
      }
      else {
        installment = 0;

      }
    
      
      installment = Number.parseFloat(installment.toString());
      
      installment = Math.round(installment)
    }


    installment = Number.parseFloat(installment.toString());
    
    this.loanform.patchValue({
      installments:  installment.toFixed(0),
      installmentsamount:installmentamount
    })

  }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.loanid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetLoan();
      }


    });
  }

  
  public fnDeleteRepaymentConfirm(deptid, reftxt) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete repayment?')
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteForm(deptid, reftxt)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid, reftxt) {
    var data = {
      'loandetid': deptid,
    }
    this.appService.fnDeleteLoanDetails(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The repayment has been deleted successfully.");
            this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetLoan();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


    //Attachment
    fnGetAttachmentCount() {
      if (this.loanid > 0) {
        var data = {
          'trxid': this.loanid,
          'trxtype': this.formname,
        }
  
  
        this.appService.fngetAttachmentCountDetails(data).subscribe(
          (res) => {
            if (res.json().status === 200) {
              var result = res.json().result;
              if (result.length > 0) {
                this.attachmentcount = result[0].attachmentcount
              }
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
  
    }
    fnAddActivity(){

      const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
      modalRef.componentInstance.formname = this.formname;
      modalRef.componentInstance.trxid = this.loanid;
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      
  
       
      });
  
    } 
  

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }

  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.ismanualclose || this.isviewmode) {
      return true;
    }
    else {
      return false;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag(){
    this.submitted=false;
    this.successfully=false;
}
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}